import { render, staticRenderFns } from "./template.html?vue&type=template&id=76f268be&scoped=true&external"
import script from "./JointTouroku.vue?vue&type=script&lang=js"
export * from "./JointTouroku.vue?vue&type=script&lang=js"
import style0 from "./style.scss?vue&type=style&index=0&id=76f268be&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f268be",
  null
  
)

export default component.exports